<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none">
      <el-row style="align-items: center; display: flex;">
        <el-col :span="8">
          <div>推荐官收益图片：715*150px</div>
          <el-upload ref="upload" :file-list="fileList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadAdvertiseImageSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
        <el-col :span="8">
          <div>活动专区图片：宽750px</div>
          <el-upload ref="uploadP" :file-list="picList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadAdvertisePicSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove1">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
        <el-col :span="8">
          <div>小程序预约头图：686*256px</div>
          <el-upload ref="uploadM" :file-list="picBookList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadAdvertisePicBookSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove2">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row style="align-items: center; display: flex; width: 500px; justify-content: center; margin-top: 50px;">
        <el-button size="medium" type="success" @click="updateAdverise()"
          v-if="checkButtonPermission('front:manage:setting:edit')">保存图片</el-button>
      </el-row>
    </el-card>
    <el-dialog :visible.sync="imageDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "wechatSetting",
  data() {
    return {
      key: '',
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 0,
      total: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      imageDialogVisible: false,
      uploadImage: '',
      fileList: [],
      linkFlag: false,
      linkVal: '',
      articles: [],
      posterFlag: false,
      posterSelect: '',
      posterSelectVal: -1,
      posters: [],
      picFlag: false,
      pageTitle: '',
      uploadPic: '',
      picList: [],
      picBookList: []
    }
  },
  created() {
    this.getWechatsetting();
  },
  methods: {
    getWechatsetting() {
      this.$http.post('/api/front-service/wechatsetting/search', {}).then(resp => {
        console.log(resp);
        let data = resp.data;
        if ("success" === data.code) {
          // 绑定数据
          let tmp = {};
          this.fileList = [];
          this.picList = [];
          this.picBookList = [];
          Object.assign(tmp, data.data);
          this.recommendUrl = tmp.recommendUrl || '';
          if (this.recommendUrl) {
            let imgObj = new Object();
            imgObj.url = tmp.recommendUrl;
            this.fileList.push(imgObj)
          }
          this.activityUrl = tmp.activityUrl || '';
          if (this.activityUrl) {
            let picObj = new Object();
            picObj.url = tmp.activityUrl;
            this.picList.push(picObj)
          }
          this.scanQrcodeBookUrl = tmp.scanQrcodeBookUrl || '';
          if (this.scanQrcodeBookUrl) {
            let picBookObj = new Object();
            picBookObj.url = tmp.scanQrcodeBookUrl;
            this.picBookList.push(picBookObj)
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    uploadAdvertiseImageSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.recommendUrl = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    uploadAdvertisePicSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.activityUrl = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    uploadAdvertisePicBookSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.scanQrcodeBookUrl = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.recommendUrl = '';
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
      this.activityUrl = '';
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
      this.scanQrcodeBookUrl = '';
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imageDialogVisible = true;
    },
    updateAdverise() {
      let reqParam = {
        recommendUrl: this.recommendUrl || '',
        activityUrl: this.activityUrl || '',
        scanQrcodeBookUrl: this.scanQrcodeBookUrl || ''
      };
      this.$http.post('/api/front-service/wechatsetting/updateUrl', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.getWechatsetting();
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {
        this.$alert('' + e, '温馨提示', {
          confirmButtonText: '确定'
        });
      })
    },

    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/wechatSetting.vue